import { keyGroups } from '../../lib/keys.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- mail-keys-dialog ---
let __fez_component_0;
{

__fez_component_0 = class {
  init() {
    this.state.groups = keyGroups()
  }

  CSS = `:fez {
display:block;.keys{display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:var(--space-6)}.keys-title{margin-bottom:var(--space-2);color:var(--color-text-subtle);font-size:var(--text-xs);font-weight:var(--weight-bold);letter-spacing:0.06em;text-transform:uppercase}.keys-row{display:flex;align-items:center;justify-content:space-between;gap:var(--space-3);padding:var(--space-2) 0;border-bottom:1px solid var(--color-border);font-size:var(--text-sm)}
}`

  HTML = `<div class="keys">
{#each state.groups as group}
<section>
<h3 class="keys-title">{group.title}</h3>
{#each group.keys as item}
<div class="keys-row">
<span>{item.label}</span>
<ui-kbd keys={item.keys}></ui-kbd>
</div>
{/each}
</section>
{/each}
</div>`
};
}

Fez('mail-keys-dialog', __fez_component_0);

export default __fez_component_0;
